var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"practice-game-wrapper"},[_c('games-player',{attrs:{"game":_vm.game}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }